import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";
export const useStyles = makeStyles(() => ({
  exam: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
      "& .Mui-disabled": {
        borderRadius: "50px",
        background: "#f9f9f9 !important",
      },
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
        background: "#FEB62C",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    "&.MuiPaper-root ": {
      background: "#F5F5FA !important",
    },
  },
  input_label: {
    marginRight: "20px",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  heading: {
    display: "flex",
    alignItems: "center",
    fontSize: "20px",
  },
  cardGaps: {
    marginBottom: "20px",
    marginTop: "20px",
  },
  title: {
    fontSize: "20px",
    fontFamily: "public sans !important",
    fontWeight: "700 !important",
  },
  search_btn: {
    marginLeft: "10px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
    width: "100px",
  },
  cancel_btn: {
    marginLeft: "10px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `#979797 !important`,
    background: `#EAECF0 !important`,
    width: "100px",
  },
  textgap: {
    fontFamily: "inter !important",
  },
  attendanceForm: {
    display: "flex",
    flexWrap: "wrap",

    alignItems: "flex-end",
    gap: "16px",
    "& .Mui-disabled": {
      color: "#767676 !important",
      background: "lightgrey !important",
    },
  },
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: `${color.darkGreen} !important`,
  },
  upload_btn: {
    fontWeight: "500 !important",
    fontSize: "0.875rem !important",
    minWidth: "20px !important",
    background: "#25D5A1 !important",
    minHeight: "20px !important",
    borderRadius: "8px !important",
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%)",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
}));
